var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMerl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0237732,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(-0.042554 0 0.0237732)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16342 24.8366 3.46192e-10 16 2.23021e-10C7.16342 0 0 7.16342 -2.23021e-10 16C-2.79154e-10 20.0271 1.48781 23.7067 3.94374 26.5192L12.5059 18.58C12.6002 18.4219 12.6726 18.2509 12.7207 18.0717L12.8724 17.5055L8.22582 16.8149C7.68107 16.7339 7.68107 15.9482 8.22582 15.8673L12.376 15.2504L7.57202 8.76907C7.24405 8.32659 7.79959 7.77111 8.24207 8.09901L14.7247 12.904L15.3419 8.75118C15.4229 8.20643 16.2086 8.20643 16.2895 8.75118L16.9065 12.9019L23.3863 8.09901C23.8288 7.77111 24.3843 8.32659 24.0563 8.76907L19.2527 15.25L23.4056 15.8673C23.9504 15.9482 23.9504 16.7339 23.4056 16.8149L19.2525 17.4322L24.0563 23.9133C24.3843 24.3558 23.8288 24.9114 23.3863 24.5834L16.9064 19.7805L16.2895 23.931C16.2086 24.4757 15.4229 24.4757 15.3419 23.931L14.651 19.2826L13.9924 19.4591C13.9042 19.4827 13.8197 19.517 13.7406 19.5608L5.70869 28.2515C8.49067 30.5909 12.0808 32 16 32Z",
    fill: "url(#paint0_linear_1278_2)",
    fillOpacity: 0.73
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1278_2",
    x1: 4.01569,
    y1: 4.51765,
    x2: 29.6157,
    y2: 32.1255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerl);
export default __webpack_public_path__ + "static/media/MERL.d00c6edcec73d7b9705cbd78ca76167e.svg";
export { ForwardRef as ReactComponent };